import React from "react";
import CreatableSelect from "react-select/creatable";
import { Redirect } from "react-router-dom";
import {
  Alert,
  Row,
  Col,
  Form,
  Button,
  Spinner,
  Image,
  Card,
} from "react-bootstrap";
import {
  fetchArtists,
  fetchLabels,
  fetchGenres,
  fetchAlbum,
  putAlbum,
  postAlbum,
  postArtist,
  postGenre,
  postLabel,
  deleteAlbum,
  getSpotifyToken,
  searchSpotify,
  searchSpotifyByID,
} from "./services/DataService";
import { stringToDate, dateToString } from "./services/UtilityService";
import DeleteAlert from "./components/DeleteAlert";
import DatePicker from "react-datepicker";
import QRCode from "qrcode.react";
import "./style/form.scss";
import "./style/add-album-print.scss";
import "./style/add-album.scss";
import "react-datepicker/dist/react-datepicker.css";

const spotify_image = require("./images/spotify.png");

class AddAlbum extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      artists: [],
      artistsById: {},
      filteredArtists: [],
      artistFilters: "",
      loadingArtists: false,
      labels: [],
      labelsById: {},
      filteredLabels: [],
      labelFilters: "",
      loadingLabels: false,
      genres: [],
      genresById: {},
      filteredGenres: [],
      genreFilters: "",
      loadingGenres: false,
      print: false,
      spotify_albums: [],
      maxResults: 50,
      date_kugs_released: new Date(),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDeleteCallback = this.onDeleteCallback.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
    this.searchSong = this.searchSong.bind(this);
  }

  reduceIdName(map, obj) {
    map[obj.id] = obj.name;
    return map;
  }

  componentDidMount() {
    Promise.all([fetchArtists(), fetchGenres("0"), fetchLabels()]).then(
      ([artists, genres, labels]) => {
        let artistsById = artists.reduce(this.reduceIdName, {});
        let genresById = genres.reduce(this.reduceIdName, {});
        let labelsById = labels.reduce(this.reduceIdName, {});
        this.setState(
          {
            artists: artists,
            artistsById: artistsById,
            filteredArtists: artists.slice(0, this.state.maxResults),
            genres: genres,
            genresById: genresById,
            filteredGenres: genres.slice(0, this.state.maxResults),
            labels: labels,
            labelsById: labelsById,
            filteredLabels: labels.slice(0, this.state.maxResults),
          },
          async () => {
            var spotify_token = await getSpotifyToken();
            localStorage.setItem(
              "spotify_token",
              spotify_token["access_token"]
            );
            localStorage.setItem("spotify_exp", spotify_token["expires_in"]);
            this.setState({ loading: false });

            if (this.props.match.params.id) {
              fetchAlbum(this.props.match.params.id).then((album) => {
                album["artist"] =
                  album.artist_id !== 0 ? artistsById[album.artist_id] : "";
                album["genre"] =
                  album.genre_id !== 0 ? genresById[album.genre_id] : "";
                album["label"] =
                  album.label_id !== 0 ? labelsById[album.label_id] : "";
                album["date_kugs_released"] =
                  album.date_kugs_released !== ""
                    ? stringToDate(album.date_kugs_released)
                    : "";

                // album["date_kugs_released"] = album["date_kugs_released"].slice(0,10)
                this.setState({ ...album, loading: false });
                // @todo: autosearch spotify (async) for albums that don't have a spotify id
                searchSpotify(album["title"], "album").then((results) => {
                  this.setState({
                    spotify_albums: results["albums"]["items"],
                  });
                });
              });
            }
          }
        );
      }
    );
  }

  submitCallback(id) {
    let newID = id ? id : this.state.id;
    this.setState({
      id: newID,
      alert: (
        <Alert variant="secondary">
          <Alert.Heading>Submission Successful</Alert.Heading>
          <hr />
          <p>The album has been added/updated.</p>
          <div className="d-flex justify-content-end">
            <Button
              onClick={() =>
                this.setState({ alert: false }, () => {
                  setTimeout(window.print, 500);
                })
              }
              variant="outline-secondary"
            >
              Print
            </Button>
            <div style={{ padding: "10px" }}></div>
            <Button
              onClick={() => this.setState({ redirect: "/albums" })}
              variant="outline-secondary"
            >
              Close
            </Button>
          </div>
        </Alert>
      ),
    });
  }
  addSpotify(spotify_album, event) {
    let artist = spotify_album.artists[0]["name"];
    let notNewArtist = this.state.artists.filter(
      (item) => item.name === artist
    );
    if (notNewArtist.length !== 0) {
      this.setState({
        artist_id: notNewArtist[0]["id"],
        artist: notNewArtist[0]["name"],
      });
    } else {
      postArtist({ name: artist }).then((id) => {
        let artists = this.state.artists;
        artists.push({ id: id.id, name: artist });
        this.setState({
          artist_id: id.id,
          artist: artist,
          artists: artists,
        });
      });
    }
    var id = spotify_album.external_urls["spotify"].replace(
      "https://open.spotify.com/album/",
      ""
    );
    this.setState({
      image_url: spotify_album.images[0].url,
      spotify_id: id,
    });
  }
  searchSong() {
    searchSpotify(this.state.title, "album").then((results) => {
      this.setState({
        spotify_albums: results["albums"]["items"],
      });
    });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    this.setState({ validated: true });
    var isValid = form.checkValidity();
    if (isValid) {
      let image_url = "";
      if (this.state.spotify_id) {
        var result = await searchSpotifyByID(this.state.spotify_id);
        if (result === undefined) {
          this.setState({ spotifyIdIsInValid: true });
          return;
        }
        image_url = result.images[0].url;
      }
      let album = {
        title: this.state.title,
        date_kugs_released: dateToString(this.state.date_kugs_released),
        artist_id: parseInt(this.state.artist_id),
        label_id: parseInt(this.state.label_id),
        genre_id: parseInt(this.state.genre_id),
        image_url: image_url,
        spotify_id: this.state.spotify_id,
        cut_notes: this.state.cut_notes,
        print: this.state.print,
        archive: this.state.archive,
      };
      if (this.props.match.params.id) {
        album.ID = parseInt(this.props.match.params.id, 10);
        putAlbum(album).then(this.submitCallback);
      } else {
        postAlbum(album).then(this.submitCallback);
      }
    }
  };

  filter(filtered, terms, label) {
    clearTimeout(this.timeout);
    this.setState({ [`loading${label}`]: true });
    this.timeout = setTimeout(() => {
      terms = terms.toLowerCase().split(" ");
      terms.map((term) => {
        return (filtered = filtered.filter((item) =>
          `${item.name.toLowerCase()}`.includes(term)
        ));
      });
      this.setState({
        [`filtered${label}`]: filtered.slice(0, this.state.maxResults),
        [`loading${label}`]: false,
      });
    }, 800);
  }

  filterArtists() {
    this.filter(this.state.artists, this.state.artistFilters, "Artists");
  }

  filterLabels() {
    this.filter(this.state.labels, this.state.labelFilters, "Labels");
  }

  filterGenres() {
    this.filter(this.state.genres, this.state.genreFilters, "Genres");
  }

  onDelete() {
    this.setState({ deleteAlert: true });
  }

  onDeleteCallback() {
    this.setState({ deleteAlert: false, redirect: "/albums" });
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.alert) {
      return this.state.alert;
    }
    let printContent;
    if (this.state.id && this.state.artist) {
      printContent = (
        <div className="print">
          <div className="title">
            {this.state.artist}, {this.state.title}
          </div>
          <div className="genre">{this.state.genre}</div>
          <div className="date">
            {dateToString(this.state.date_kugs_released)}
          </div>
          <div className="cuts">CUTS: {this.state.cut_notes}</div>
          <div className="label">{this.state.label}</div>
          <div className="album-id">{this.state.id}</div>
          <div className="kugs-fm">KUGS FM</div>
          <div className="artist-letter-1">{this.state.artist.charAt(0)}</div>
          <div className="artist-letter-2">{this.state.artist.charAt(0)}</div>
          <div className="artist-letter-3">{this.state.artist.charAt(1)}</div>
          <div className="artist-letter-4">{this.state.artist.charAt(2)}</div>
          <div className="qrcode">
            <QRCode value={this.state.id.toString()} />
          </div>
        </div>
      );
    }
    let deleteAlert;
    if (this.state.deleteAlert) {
      deleteAlert = (
        <DeleteAlert
          onConfirm={() => {
            deleteAlbum(this.props.match.params.id).then(this.onDeleteCallback);
          }}
          onCancel={() => this.setState({ deleteAlert: false })}
        />
      );
    }
    let printButton;
    if (this.props.match.params.id) {
      printButton = (
        <div className="d-flex justify-content-center">
          <Button
            variant="secondary"
            className="glyphicon glyphicon-print btn-print-item"
            onClick={() => window.print()}
          ></Button>
        </div>
      );
    }
    let deleteButton;
    if (this.props.match.params.id) {
      deleteButton = (
        <div className="d-flex justify-content-center">
          <Button
            variant="danger"
            className="btn-delete"
            onClick={this.onDelete}
          >
            Delete
          </Button>
        </div>
      );
    }
    let spotifyAlbums;
    if (this.state.spotify_albums && this.state.spotify_albums.length) {
      spotifyAlbums = (
        <div className="d-flex justify-content-center spotify-card-container">
          {this.state.spotify_albums.slice(0, 3).map((album) => {
            return (
              <Card key={album.id}>
                <Card.Img variant="top" src={album.images[1].url} />
                <Card.Body>
                  <Card.Title>{album.name}</Card.Title>
                  <Card.Text>
                    Artist: {album.artists[0].name}
                    <br />
                    Released: {album.release_date}
                    <br />
                    Tracks: {album.total_tracks}
                  </Card.Text>

                  <Button
                    variant="primary"
                    onClick={() => {
                      this.addSpotify(album);
                    }}
                  >
                    KUGS IT!
                  </Button>
                  <Button
                    variant="dark"
                    className="spotify-button"
                    onClick={() => {
                      window.open(album.external_urls["spotify"]);
                    }}
                  >
                    <Image src={spotify_image} />
                  </Button>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      );
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    return (
      <div>
        {printContent}
        {deleteAlert}
        <div className="form-title">
          {this.props.match.params.id ? "Edit" : "Add"} an Album
        </div>
        {this.state.image_url ? (
          <Image className="album-image" src={this.state.image_url} />
        ) : (
          ""
        )}
        <Form
          className="form"
          noValidate
          validated={this.state.validated}
          onSubmit={this.handleSubmit}
        >
          <Form.Group as={Row}>
            <Form.Label column sm="3">
              Title
            </Form.Label>
            <Col sm="7">
              <Form.Control
                required
                type="text"
                name="title"
                onChange={this.onChange}
                value={this.state.title || ""}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a title.
              </Form.Control.Feedback>
            </Col>
            <Col sm="1">
              <Button onClick={this.searchSong}>search</Button>
            </Col>
            <Form.Label column sm="3">
              Artist
            </Form.Label>
            <Col sm="9">
              <CreatableSelect
                className="kugs-createable-select"
                isLoading={this.state.loadingArtists}
                placeholder=""
                value={{
                  label: this.state.artist,
                  value: this.state.artist_id,
                }}
                options={
                  this.state.artist_id
                    ? []
                    : this.state.filteredArtists.map((artist) => ({
                        label: artist.name,
                        value: artist.id,
                      }))
                }
                isClearable
                onKeyDown={(e) => {
                  this.setState(
                    {
                      artistFilters: e.target.value,
                      artist_id: null,
                      artist: null,
                    },
                    this.filterArtists
                  );
                }}
                onChange={(artist) => {
                  if (artist) {
                    if (artist.__isNew__) {
                      postArtist({ name: artist.label }).then((id) => {
                        let artists = this.state.artists;
                        artists.push({ id: id.id, name: artist.label });
                        this.setState({
                          artist_id: id.id,
                          artist: artist.label,
                          artists: artists,
                        });
                      });
                    } else {
                      this.setState({
                        artist_id: artist.value,
                        artist: artist.label,
                      });
                    }
                  } else {
                    this.setState({ artist_id: null, artist: null });
                  }
                }}
              />
            </Col>
            <Form.Label column sm="3">
              Label
            </Form.Label>
            <Col sm="9">
              <CreatableSelect
                className="kugs-createable-select"
                isLoading={this.state.loadingLabels}
                placeholder=""
                value={{
                  label: this.state.label,
                  value: this.state.label_id,
                }}
                options={
                  this.state.label_id
                    ? []
                    : this.state.filteredLabels.map((label) => ({
                        label: label.name,
                        value: label.id,
                      }))
                }
                isClearable
                onKeyDown={(e) => {
                  this.setState(
                    {
                      labelFilters: e.target.value,
                      label_id: null,
                      label: null,
                    },
                    this.filterLabels
                  );
                }}
                onChange={(label) => {
                  if (label) {
                    if (label.__isNew__) {
                      postLabel(label.label).then((id) => {
                        let labels = this.state.labels;
                        labels.push({ id: id.id, name: label.label });
                        this.setState({
                          label_id: id.id,
                          label: label.label,
                          labels: labels,
                        });
                      });
                    } else {
                      this.setState({
                        label_id: label.value,
                        label: label.label,
                      });
                    }
                  } else {
                    this.setState({ label_id: null, label: null });
                  }
                }}
              />
            </Col>
            <Form.Label column sm="3">
              Genre
            </Form.Label>
            <Col sm="9">
              <CreatableSelect
                className="kugs-createable-select"
                isLoading={this.state.loadingGenres}
                placeholder=""
                value={{
                  label: this.state.genre,
                  value: this.state.genre_id,
                }}
                options={
                  this.state.genre_id
                    ? []
                    : this.state.filteredGenres.map((genre) => ({
                        label: genre.name,
                        value: genre.id,
                      }))
                }
                isClearable
                onKeyDown={(e) => {
                  this.setState(
                    {
                      genreFilters: e.target.value,
                      genre_id: null,
                      genre: null,
                    },
                    this.filterGenres
                  );
                }}
                onChange={(genre) => {
                  if (genre) {
                    if (genre.__isNew__) {
                      postGenre(genre.label).then((id) => {
                        let genres = this.state.genres;
                        genres.push({ id: id.id, name: genre.label });
                        this.setState({
                          genre_id: id.id,
                          genre: genre.label,
                          genres: genres,
                        });
                      });
                    } else {
                      this.setState({
                        genre_id: genre.value,
                        genre: genre.label,
                      });
                    }
                  } else {
                    this.setState({ genre_id: null, genre: null });
                  }
                }}
              />
            </Col>
            <Form.Label column sm="3">
              Date Kugs Released
            </Form.Label>
            <Col sm="9">
              <DatePicker
                className="form-control"
                selected={this.state.date_kugs_released}
                required
                isInvalid
                onChange={(date) => {
                  this.setState({ date_kugs_released: date });
                }}
              />
            </Col>
            {this.state.release_date ? (
              <>
                <Form.Label column sm="3">
                  Date Released
                </Form.Label>
                <Col sm="3">
                  <Form.Control
                    type="text"
                    readOnly={true}
                    value={this.state.release_date}
                  />
                </Col>
              </>
            ) : (
              ""
            )}
            {this.state.total_tracks ? (
              <>
                <Form.Label column sm="3">
                  Track Count
                </Form.Label>
                <Col sm="3">
                  <Form.Control
                    type="text"
                    readOnly={true}
                    value={this.state.total_tracks}
                  />
                </Col>
              </>
            ) : (
              ""
            )}
            <Form.Label column sm="3">
              Cut Notes
            </Form.Label>
            <Col sm="9">
              <Form.Control
                type="text"
                name="cut_notes"
                onChange={this.onChange}
                value={this.state.cut_notes || ""}
              />
            </Col>
            <Form.Label column sm="3">
              Spotify ID
            </Form.Label>
            <Col sm="9">
              <Form.Control
                type="text"
                name="spotify_id"
                onChange={this.onChange}
                isInvalid={this.state.spotifyIdIsInValid}
                value={this.state.spotify_id || ""}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a Valid Spotify ID.
              </Form.Control.Feedback>
            </Col>
            <Form.Label column sm="2">
              Print
            </Form.Label>
            <Form.Check
              className="print-checkbox"
              type="checkbox"
              name="print"
              label=""
              checked={this.state.print}
              onChange={() => {
                this.setState({ print: !this.state.print });
              }}
            />
            <Form.Label column sm="2">
              Archive
            </Form.Label>
            <Form.Check
              className="print-checkbox"
              type="checkbox"
              name="archive"
              label=""
              checked={this.state.archive}
              onChange={() => {
                this.setState({ archive: !this.state.archive });
              }}
            />
            {this.state.spotify_id ? " " : spotifyAlbums}
          </Form.Group>
          <div className="d-flex justify-content-center btn-container">
            {printButton}
            <Button variant="primary" type="submit" className="btn-submit">
              {this.props.match.params.id ? "Update" : "Add"}
            </Button>
            {deleteButton}
          </div>
        </Form>
      </div>
    );
  }
}

export default AddAlbum;
